<template>
<div class="error-page flex justify-center items-center flex-col">
  <h1 class="text-3xl font-bold mb-4">Страница не найдена</h1>
  <p class="mb-4 text-center">Убедитесь, что вы перешли по правильной ссылке.</p>
  <router-link :to="{ name: 'home' }" class="btn btn-primary btn-large rounded">
    Перейти на главную
  </router-link>
</div>
</template>

<script>
import InjectsSeo from '@/mixins/InjectsSeo'

export default {
  mixins: [InjectsSeo],

  metaInfo() {
    return {
      title: this.getFullPageTitle('Страница не найдена'),
      description: '',
    }
  },
}
</script>
